import { AlinaStatus } from "../../config";

export const isCaseProgressDone = (status, caseDetails) => {
  let currentStatusIdx = AlinaStatus.indexOf(caseDetails.status);
  if (caseDetails.status === "For payment") {
    const lastCaseProgress =
      caseDetails.caseProgressions[caseDetails.caseProgressions.length - 1];
    if (lastCaseProgress.type === "F2F Consultation") {
      currentStatusIdx = AlinaStatus.indexOf("For F2F consultation");
    } else if (lastCaseProgress.type === "Scanning") {
      currentStatusIdx = AlinaStatus.indexOf("For scanning");
    } else if (lastCaseProgress.type === "Design") {
      currentStatusIdx = AlinaStatus.indexOf("Design in progress");
    } else if (lastCaseProgress.type === "Set") {
      currentStatusIdx = AlinaStatus.indexOf("For fabrication");
    }
  }
  const statusIdx = AlinaStatus.indexOf(status);
  if (currentStatusIdx > statusIdx) {
    return true;
  }
  return false;
};
